module.exports = __webpack_public_path__ + "static/media/Bear Costume.8c4723f1.jpg";